import { CandidateBatchStatus } from 'generated-graphql/types';

export const isAnalyseProcessing = (status: CandidateBatchStatus) =>
  [
    CandidateBatchStatus.Created,
    CandidateBatchStatus.ReadyToProcess,
    CandidateBatchStatus.PreProcessing
  ].includes(status);
